import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-1">
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList>
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="inline-flex items-center justify-center h-9 px-4 text-sm font-medium text-foreground hover:text-primary transition-colors duration-[var(--duration-fast)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  return <header className="sticky top-0 z-50 w-full bg-background border-b border-border shadow-soft">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-auto py-4">
          {}
          <Link to="HomePage" className="flex items-center">
            <img src="https://gp2bcexpress.com/wp-content/uploads/2025/10/G22bcexpressmapleleaf.png" alt="G2BC Express maple leaf logo" className="h-[100px]" />
          </Link>

          {}
          <nav className="hidden md:flex items-center">
            <MenuProvider menu_id="6">
              <HeaderMenuConsumer />
            </MenuProvider>
          </nav>

          {}
          <Button asChild className="bg-primary text-white hover:bg-primary-hover active:bg-primary-active shadow-soft hover:shadow-medium transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
            <Link to="#contact-us">Contact Us</Link>
          </Button>
        </div>
      </div>
    </header>;
}